var map = {
	"./AnchorLogo.svg": 7119,
	"./acadmy.svg": 54082,
	"./add-user.svg": 74876,
	"./add_box.svg": 83686,
	"./alert.svg": 74153,
	"./alert2.svg": 90049,
	"./analytics.svg": 68383,
	"./arrow-2.svg": 12537,
	"./arrow-down.svg": 55041,
	"./arrow-next.svg": 46752,
	"./arrow-prev.svg": 61728,
	"./arrow-right.svg": 38633,
	"./arrow-top.svg": 72452,
	"./arrow-up-down.svg": 53851,
	"./arrow-up.svg": 44008,
	"./arrow.svg": 60510,
	"./bag.svg": 62305,
	"./bold-arrow.svg": 21298,
	"./bookmark.svg": 95481,
	"./calendar-pen.svg": 36705,
	"./calendar.svg": 58579,
	"./calendar2.svg": 20843,
	"./card-like.svg": 31549,
	"./card-mark.svg": 64459,
	"./card-play.svg": 45948,
	"./card-repeat.svg": 34473,
	"./card-share.svg": 17293,
	"./checkbox-circle.svg": 27835,
	"./checkbox.svg": 8268,
	"./checked-circle.svg": 28069,
	"./checked.svg": 82542,
	"./checked2.svg": 3264,
	"./circle-menu.svg": 51319,
	"./click.svg": 47747,
	"./close-circle-2.svg": 54253,
	"./close-circle.svg": 24778,
	"./close.svg": 39495,
	"./close2.svg": 8663,
	"./collection.svg": 83569,
	"./color-pick.svg": 94106,
	"./comment.svg": 91574,
	"./comments.svg": 22299,
	"./copy-link.svg": 61667,
	"./copy.svg": 55864,
	"./date.svg": 7689,
	"./delete.svg": 9986,
	"./delete2.svg": 36412,
	"./deselect.svg": 44242,
	"./disabled.svg": 28997,
	"./doc.svg": 69909,
	"./domain.svg": 46129,
	"./down.svg": 38325,
	"./download.svg": 41705,
	"./download2.svg": 68545,
	"./download3.svg": 25142,
	"./draft.svg": 33696,
	"./drag.svg": 38007,
	"./edit.svg": 94113,
	"./email.svg": 37963,
	"./empty-collection-icon.svg": 8257,
	"./engagement.svg": 54246,
	"./eye-hidden.svg": 72489,
	"./eye.svg": 79138,
	"./facebook.svg": 54369,
	"./file-finger.svg": 78583,
	"./file.svg": 29079,
	"./filter.svg": 73307,
	"./flag-2.svg": 29288,
	"./flag-color.svg": 20961,
	"./flag.svg": 94507,
	"./go-out.svg": 39438,
	"./help.svg": 56258,
	"./history-menu.svg": 6761,
	"./home.svg": 33798,
	"./idea.svg": 4370,
	"./image.svg": 722,
	"./import.svg": 12728,
	"./info.svg": 49333,
	"./instagram.svg": 99423,
	"./less.svg": 77436,
	"./lightning.svg": 87125,
	"./likes.svg": 7219,
	"./link.svg": 82041,
	"./lock.svg": 57066,
	"./logo-m.svg": 62956,
	"./logo.svg": 99378,
	"./menu-arrow.svg": 29614,
	"./menu.svg": 86498,
	"./money.svg": 5523,
	"./more.svg": 93796,
	"./motom.svg": 43983,
	"./move.svg": 56776,
	"./next.svg": 59068,
	"./not-allow.svg": 81050,
	"./organize.svg": 51632,
	"./package.svg": 67551,
	"./pen.svg": 45268,
	"./pen2.svg": 88462,
	"./pig.svg": 38659,
	"./pinterest-no-circle.svg": 34682,
	"./plus-filled.svg": 44916,
	"./plus.svg": 81445,
	"./plus2.svg": 88229,
	"./power-by.svg": 37412,
	"./preview.svg": 77627,
	"./processing.svg": 60046,
	"./programs.svg": 96732,
	"./question-2.svg": 16902,
	"./question-3.svg": 31953,
	"./question.svg": 38229,
	"./queue.svg": 97052,
	"./refrash.svg": 23740,
	"./refresh.svg": 84648,
	"./remove.svg": 63309,
	"./retry.svg": 45577,
	"./rotate-right.svg": 49989,
	"./rotate.svg": 55202,
	"./sales.svg": 63515,
	"./scheduled.svg": 34492,
	"./search.svg": 265,
	"./select.svg": 90925,
	"./send-email.svg": 15994,
	"./send.svg": 44723,
	"./setting.svg": 50207,
	"./share-2.svg": 5595,
	"./share.svg": 47788,
	"./shareto.svg": 37761,
	"./shopping-cart.svg": 28710,
	"./sort-three-line.svg": 64585,
	"./sort.svg": 11873,
	"./star-filled.svg": 70264,
	"./stop.svg": 6613,
	"./storefront.svg": 94489,
	"./storefront2.svg": 74289,
	"./tag-plus.svg": 86630,
	"./tag.svg": 44439,
	"./tagProcessing.svg": 17476,
	"./tagQueue.svg": 51882,
	"./tiktok-pure.svg": 15080,
	"./tiktok.svg": 98375,
	"./tip.svg": 2130,
	"./todo.svg": 54797,
	"./top-rank-flag-2.svg": 65945,
	"./top-rank-flag.svg": 1438,
	"./twitter-no-circle.svg": 92099,
	"./unlink.svg": 42074,
	"./upload.svg": 91872,
	"./upload2.svg": 48578,
	"./user-circle-gear.svg": 75931,
	"./user-list.svg": 31769,
	"./users-2.svg": 9900,
	"./users.svg": 37111,
	"./verified.svg": 79813,
	"./waiting.svg": 36316,
	"./warning.svg": 9059,
	"./yes-2.svg": 30227,
	"./yes-3.svg": 42992,
	"./yes.svg": 88276,
	"./youtube.svg": 61238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36933;